import parse from 'Js/api/lib/parse';

export function objToArray(value) {
    if (Object.prototype.toString.call(value) == '[object Array]') {
        return value;
    } else if (value && value.length >= 0) {
        return Array.prototype.slice.call(value);
    } else if (value) {
        return [value];
    }
    return [];
}

/**
 * Формирует из объекта строку с параметрами запроса
 * name=value&name=value...
 * @param {Object} obj
 * @returns {string}
 */
export function objToQueryString(obj) {
    return (
        Object.keys(obj)
            .reduce((query, name) => {
                const value = obj[name];
                if (Array.isArray(value)) {
                    value.forEach(v => query.push([name, v]));
                } else {
                    query.push([name, obj[name]]);
                }
                return query;
            }, [])
            // Неопределённые параметры игнорируются,
            // так же, как они игнорируются при сериализации JSON.stringify
            .filter(([, value]) => value !== undefined)
            .map(
                param =>
                    `${encodeURIComponent(param[0])}=${encodeURIComponent(
                        param[1]
                    )}`
            )
            .join('&')
    );
}

export function xmlToJson(src) {
    const xml = typeof src == 'string' ? parse.xml(src) : src;
    let obj = {};
    // Если нода представляет собой элемент, у него могут быть атрибуты
    if (xml.nodeType == 1) {
        if (xml.attributes.length > 0) {
            obj['@attributes'] = {};
            for (let j = 0; j < xml.attributes.length; j += 1) {
                const attribute = xml.attributes.item(j);
                obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
            }
        }
    } // Если нода текстовая, просто записываем значение
    else if (xml.nodeType == 3) {
        obj = xml.nodeValue;
    }
    // Проходим по потомкам
    if (xml.hasChildNodes()) {
        for (let i = 0; i < xml.childNodes.length; i += 1) {
            const item = xml.childNodes.item(i);
            const { nodeName } = item;
            if (obj[nodeName] === undefined) {
                obj[nodeName] = xmlToJson(item);
            } else {
                if (obj[nodeName].push === undefined) {
                    const old = obj[nodeName];
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                }
                obj[nodeName].push(xmlToJson(item));
            }
        }
    }
    return obj;
}
const strToJson = parse.json;

export { strToJson };
